module.exports = __webpack_public_path__ + "static/img/1481_phase_function_Paper_PointsHejduk_Prediction.98e1f98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1481_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Mt9B
// module chunks = 0